document.addEventListener('DOMContentLoaded', () => {

  // Carrusel de Pasos (Manual)
  const stepSections = document.querySelectorAll('.steps-carousel-container');
  stepSections.forEach(section => {
    const carousel = section.querySelector('.steps-carousel');
    const slides = section.querySelectorAll('.step-slide');
    const prevArrow = section.querySelector('.prev-arrow');
    const nextArrow = section.querySelector('.next-arrow');
    let currentIndex = 0;

    const updateCarousel = () => {
      carousel.style.transform = `translateX(-${currentIndex * 100}%)`;
    };

    if (prevArrow && nextArrow) {
      prevArrow.addEventListener('click', () => {
        currentIndex = (currentIndex > 0) ? currentIndex - 1 : slides.length - 1;
        updateCarousel();
      });

      nextArrow.addEventListener('click', () => {
        currentIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
        updateCarousel();
      });
    }
  });

  // Manejar la reproducción de video
  const videoPlayers = document.querySelectorAll('.how-to-use-section .video-player');
  videoPlayers.forEach(player => {
    const videoUrl = player.dataset.videoUrl;

    if (videoUrl) {
      player.addEventListener('click', () => {
        let finalUrl = '';
        if (videoUrl.includes('youtube.com')) {
          const videoId = videoUrl.split('v=')[1];
          finalUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        } else if (videoUrl.includes('vimeo.com')) {
          const videoId = videoUrl.split('/').pop();
          finalUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        }

        if (finalUrl) {
          const iframe = document.createElement('iframe');
          iframe.setAttribute('src', finalUrl);
          iframe.setAttribute('allow', 'autoplay; encrypted-media');
          iframe.setAttribute('allowfullscreen', '');
          player.innerHTML = '';
          player.appendChild(iframe);
        }
      });
    }
  });
});